(() => {
  function init(root){
    root.querySelectorAll('[data-install-player]').forEach(player=>{
      const button=player.querySelector('.siv-play');
      if(!button || button.dataset.bound)return;
      button.dataset.bound='true';
      button.addEventListener('click',()=>{
        const frame=document.createElement('iframe');
        frame.title=player.dataset.title;
        frame.src=`https://www.youtube-nocookie.com/embed/${encodeURIComponent(player.dataset.videoId)}?autoplay=1&rel=0&playsinline=1`;
        frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen=true;
        frame.referrerPolicy='strict-origin-when-cross-origin';
        player.replaceChildren(frame);
        frame.focus();
      },{once:true});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
